/* Cross-page "your custom model is ready" notifier - see snippets/cf-design-notify.liquid. */
(function () {
  // Loaded by the snippet on the builder pages, and on any other page only while a design is in progress; a page
  // that somehow gets it twice keeps the first.
  if (window.CF_NOTIFY) return;

  var KEY      = 'cf_pending_designs';
  var API      = (window.CF && window.CF.PREVIEW_API_URL) || 'https://api.cityframes.de';
  var POLL_MS  = 6000;   // a bit snappier so the progress bar advances smoothly
  // Stop watching a design after this long (safety valve so a job that died
  // without a terminal status can't linger in localStorage forever). MUST stay
  // comfortably ABOVE the configurator's inline POLL_TIMEOUT_MS: the inline
  // watcher gives up first *on purpose* (a shopper shouldn't stare at a spinner
  // indefinitely) and this cross-page one takes over. A cold FRAME is a DAG of
  // 11 queued jobs on the heavy lane, each with the server's 600 s job timeout,
  // so it can legitimately run well past the inline ceiling — at 25 min this
  // dropped such a design silently and it never toasted at all.
  var MAX_AGE  = 45 * 60 * 1000;
  // The words, in the visitor's language (the snippet prints them); English if a page has none.
  var T = Object.assign({
    generating: 'Your model is being generated', ready: 'Your model is ready', view: 'View', close: 'Close',
    cube: 'Your Custom CUBE', frame: 'Your Custom FRAME'
  }, window.CF_NOTIFY_T || {});
  var ARROW = '<svg class="icon" aria-hidden="true" focusable="false" width="13" height="13" viewBox="0 0 16 16" fill="none"><path d="M3 8h9.6M8.8 4.2 12.6 8l-3.8 3.8" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CROSS = '<svg aria-hidden="true" focusable="false" fill="none" width="14" viewBox="0 0 16 16"><path d="m1 1 14 14M1 15 15 1" stroke="currentColor" stroke-width="1.5"/></svg>';
  var timer    = null;
  var activeId = null;             // design being watched on THIS page (runtime only)
  var toasts   = {};               // design_id -> persistent toast element

  function read()  { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (_) { return []; } }
  function write(l){ try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (_) {} }

  function prune(list) {
    var now = Date.now();
    return list.filter(function (d) {
      return d && d.id && !d.notified && (now - (d.startedAt || 0)) < MAX_AGE;
    });
  }

  // Change one design's entry in the registry (progress, shown, muted, notified).
  function update(id, fields) {
    var list = read();
    list.forEach(function (x) { if (x.id === id) Object.assign(x, fields); });
    write(prune(list));
  }

  // Public API used by the configurators.
  window.CF_NOTIFY = {
    // Idempotent. A design ALREADY in the registry (the shopper left, came back
    // and re-attached to the same in-flight job) is not re-added — but the event
    // still fires. It used to return early here, before the dispatch, so a
    // resuming configurator never heard about the design it had just attached to
    // and kept its own duplicate placeholder alongside the registry's one.
    register: function (d) {
      if (!d || !d.id) return;
      var list = read();
      if (!list.some(function (x) { return x.id === d.id; })) {
        list.push({
          id: d.id, product: d.product || 'model', title: d.title || '',
          lat: d.lat, lon: d.lon, scale: d.scale, rotation: d.rotation,
          path: d.path || location.pathname, startedAt: Date.now(), notified: false
        });
        write(prune(list));
      }
      ensurePolling();
      // Let an open configurator render its persistent "generating" card for it
      // in "Your Designs" — the registry is the ONLY source of pending cards.
      try { document.dispatchEvent(new CustomEvent('cf:design:registered', { detail: { id: d.id, product: d.product } })); } catch (_) {}
    },
    setActive: function (id) { activeId = id; },
    clear: function (id) { write(prune(read().filter(function (x) { return x.id !== id; }))); }
  };

  // Add the finished design to the per-product "Your Designs" buffer, so it shows
  // up even when the shopper returns to the configurator directly (not via the
  // toast). The configurator normally does this in its onReady — which never runs
  // if they browsed away — so the notifier fills the gap. Only called on `ready`
  // (the preview exists), so the gallery's 404-drop can't remove it. Config fields
  // default (they're chosen in step 3, AFTER generation); the configurator updates
  // its own richer entry if the shopper opens the design there.
  function addToDesignBuffer(d, previewUrl) {
    var key = (d.product === 'frame') ? 'cf_frame_designs_r1' : 'cf_cube_designs_r1';
    var CAP = 25, list;
    try { list = JSON.parse(localStorage.getItem(key)) || []; } catch (_) { list = []; }
    if (list.some(function (x) { return x.design_id === d.id; })) return;  // already there
    list.push({
      design_id: d.id, preview_url: previewUrl || '', place_name: d.title || '',
      lat: d.lat, lon: d.lon, scale: d.scale, rotation: d.rotation,
      created_at: new Date(d.startedAt || Date.now()).toISOString(),
      saved: false, trees: false, streets: false,
      cover: 'none', plaque: 'none', plaque_headline: '', plaque_subheadline: ''
    });
    try { localStorage.setItem(key, JSON.stringify(list.slice(-CAP))); } catch (_) {}
    // Let an open configurator refresh its gallery (it may have rendered before
    // this design finished — e.g. the shopper returned mid-generation).
    try { document.dispatchEvent(new CustomEvent('cf:design:buffered', { detail: { id: d.id, product: d.product } })); } catch (_) {}
  }

  // design= is the PRIMARY key — the configurator resolves it via GET /design/{id}
  // and attaches to THAT design, in-flight or finished. The coordinates ride along
  // only as a fallback (evicted design, or artifacts older than the current
  // RENDER_VERSION), which is also what pre-design= links still restore from.
  // Reconstructing the id by re-POSTing these coords was the whole problem: any
  // drift forked a second render instead of resuming the first.
  function designHref(d) {
    try {
      var u = new URL(location.origin + (d.path || '/'));
      if (d.id)                 u.searchParams.set('design', d.id);
      if (isFinite(d.lat))      u.searchParams.set('lat', d.lat);
      if (isFinite(d.lon))      u.searchParams.set('lon', d.lon);
      if (isFinite(d.scale))    u.searchParams.set('scale', d.scale);
      if (isFinite(d.rotation)) u.searchParams.set('rotation', d.rotation);
      u.searchParams.set('saved', '1');
      return u.toString();
    } catch (_) { return d.path || '/'; }
  }

  function wrapEl() {
    var w = document.querySelector('.cf-notify-wrap');
    if (!w) { w = document.createElement('div'); w.className = 'cf-notify-wrap'; document.body.appendChild(w); }
    return w;
  }

  // The design's name: its place and product ("Marienplatz, München CUBE"), or the builder's own "Your Custom CUBE".
  function designName(d) {
    var product = d.product === 'frame' ? 'FRAME' : 'CUBE';
    return d.title ? d.title + ' ' + product : (d.product === 'frame' ? T.frame : T.cube);
  }

  // One persistent toast per design: the name over "being generated" and a progress bar during the build, flipping
  // to "ready" with the picture and View when it finishes. In the store's own pieces since 2026-10-26: the name as a
  // card title (.h6), the line as small subdued text, View under them as the cards' "→ View" button (beside them it
  // squeezed the name onto three lines on a phone), the windows' round close.
  // `instant`: no slide-in - the toast was already up on the page before, and arriving again on each page read as a
  // jolt (2026-10-26).
  function getToast(d, instant) {
    if (toasts[d.id]) return toasts[d.id];
    var el = document.createElement('div');
    el.className = 'cf-notify' + (instant ? ' cf-notify--instant' : '');
    el.setAttribute('role', 'status');
    el.innerHTML =
      '<img class="cf-notify__thumb" alt="" hidden>' +
      '<div class="cf-notify__body">' +
        '<p class="cf-notify__title h6"></p>' +
        '<p class="cf-notify__sub text-xs text-subdued leading-label"></p>' +
        '<div class="cf-notify__bar" hidden><span class="cf-notify__fill"></span></div>' +
        '<a class="cf-notify__view button button--sm product-card__action product-card__action--cta" hidden>' + ARROW +
          '<span class="smallcaps product-card__action-label"></span></a>' +
      '</div>' +
      '<button type="button" class="cf-notify__close">' + CROSS + '</button>';
    el.querySelector('.cf-notify__view span').textContent = T.view;
    var close = el.querySelector('.cf-notify__close');
    close.setAttribute('aria-label', T.close);
    close.addEventListener('click', function (e) { e.stopPropagation(); dismissToast(d.id, true); });
    // The whole toast is clickable in EVERY state (generating or ready): it opens
    // the configurator on THIS design, so the shopper can continue watching the
    // in-flight generation there (or view the finished model). The × and the View
    // button handle their own clicks.
    el.addEventListener('click', function (e) {
      if (e.target.closest('.cf-notify__close, .cf-notify__view')) return;
      var href = designHref(d);
      if (href) location.href = href;
    });
    wrapEl().appendChild(el);
    toasts[d.id] = el;
    if (instant) el.classList.add('is-in');
    else requestAnimationFrame(function () { el.classList.add('is-in'); });
    return el;
  }

  function renderGenerating(d, progress, instant) {
    if (d.muted) return;   // shopper closed it — don't nag with the bar again, on this page or the next
    var el = getToast(d, instant);
    el.querySelector('.cf-notify__title').textContent = designName(d);
    el.querySelector('.cf-notify__sub').textContent = T.generating;
    el.querySelector('.cf-notify__bar').hidden = false;
    el.querySelector('.cf-notify__fill').style.width = Math.max(3, Math.min(100, Math.round(progress || 3))) + '%';
    el.querySelector('.cf-notify__view').hidden = true;
  }

  function renderReady(d, previewUrl) {
    var el = getToast(d);   // a finished model is always worth surfacing, closed bar or not
    el.querySelector('.cf-notify__title').textContent = designName(d);
    el.querySelector('.cf-notify__sub').textContent = T.ready;
    el.querySelector('.cf-notify__bar').hidden = true;
    var view = el.querySelector('.cf-notify__view'); view.hidden = false; view.href = designHref(d);
    if (previewUrl) { var t = el.querySelector('.cf-notify__thumb'); t.src = previewUrl; t.hidden = false; }
  }

  // Closed by the shopper while generating: remembered in the registry, so the next page does not bring it back.
  function dismissToast(id, byUser) {
    var el = toasts[id];
    if (el) { el.classList.remove('is-in'); setTimeout(function () { el.remove(); }, 300); }
    delete toasts[id];
    if (byUser) update(id, { muted: true });
  }

  // The toast is a CROSS-PAGE notifier: on a configurator page the inline progress
  // UI + "Your Designs" already cover every design generated there, so never pop a
  // toast here (it also dodges a race where register()'s immediate poll runs before
  // setActive(), flashing the toast for an instant with a dead bar). Tracking +
  // buffering still run so the design lands in "Your Designs" and toasts correctly
  // once the shopper navigates AWAY.
  //
  // Which product THIS page configures ('frame' | 'cube'), or null off a
  // configurator. Both configurators share the #cube-custom-configurator root id,
  // so testing for the element alone suppressed EVERY product's toast on EITHER
  // page — a FRAME finishing while the shopper sat on the CUBE configurator was
  // marked notified with no toast at all, and the CUBE page's gallery reads a
  // different buffer (cf_cube_designs_r1), so nothing surfaced it there either.
  // Suppression is now per design: only the product this page actually covers.
  // Read lazily (not cached) — this snippet loads from theme.liquid and may run
  // before the section's markup is parsed.
  function pageProduct() {
    var el = document.getElementById('cube-custom-configurator');
    return el ? (el.getAttribute('data-cf-product') || 'cube') : null;
  }
  function suppressed(d) {
    var pageP = pageProduct();
    return !!pageP && (d.product || 'cube') === pageP;
  }

  // A toast that was already up on the last page stands where it was, at its last progress, the moment this page is
  // read - it used to wait for the first answer (0.3-1 s) and slide in again from 3%.
  function restore() {
    read().forEach(function (d) {
      if (d.notified || !d.shown || d.muted || d.id === activeId || suppressed(d)) return;
      renderGenerating(d, d.progress, true);
    });
  }

  function poll() {
    if (document.hidden) return;   // a tab in the background does not ask; it asks again when it is looked at
    write(prune(read()));
    var list = read();
    if (!list.length) { stop(); return; }
    list.forEach(function (d) {
      if (d.notified) return;
      if (d.id === activeId) { dismissToast(d.id); return; }   // watched inline here — the overlay shows it
      var quiet = suppressed(d);
      fetch(API + '/preview/' + encodeURIComponent(d.id), { mode: 'cors' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) {
          if (!j) return;
          if (j.status === 'ready') {
            addToDesignBuffer(d, j.preview_url);   // land it in "Your Designs" too
            if (!quiet) renderReady(d, j.preview_url);
            update(d.id, { notified: true });
          } else if (j.status === 'error') {
            dismissToast(d.id); update(d.id, { notified: true });
          } else if (!quiet) {
            renderGenerating(d, j.progress);
            update(d.id, { progress: j.progress, shown: !d.muted });
          }
        })
        .catch(function () {});
    });
  }

  function ensurePolling() {
    if (timer) return;
    if (!prune(read()).length) return;
    timer = setInterval(poll, POLL_MS);
    poll();   // fire once immediately
  }
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  document.addEventListener('visibilitychange', function () { if (!document.hidden && timer) poll(); });

  // Resume on every page load if anything is still pending.
  function start() { restore(); ensurePolling(); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
